<template>
  <span v-html="data"></span>
</template>

<script>
export default {
  props: ['data']
}
</script>
